import React from "react";
import { Helmet } from "react-helmet-async";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneVolume } from "react-icons/fa6";
import { IoMailOpenOutline } from "react-icons/io5";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Vinayak24x7 | 24x7 Road Mechanic Jaipur</title>
        <meta
          name="description"
          content="Read the Privacy Policy for using our 24x7 car breakdown and roadside assistance service in Jaipur."
        />
        <link rel="canonical" href="https://vinayak24x7jaipur.com/terms" />
      </Helmet>
      <section className="contact__area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="contact__content">
                <div className="section-title mb-35">
                  <h2 className="title">Contact Info</h2>
                </div>
                <div className="contact__info">
                  <ul className="list-wrap">
                    <li>
                      <div className="icon">
                        <FaLocationDot />
                      </div>
                      <div className="content">
                        <h4 className="title">Address</h4>
                        <p>
                          Plot No.7, Bajrang Vihar Rd, near Durgapura Railway
                          Station, above CK BIRLA HOSPITAL, Shanti Nagar,
                          Durgapura, Jaipur, Rajasthan 302018 &nbsp;
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <FaPhoneVolume />
                      </div>
                      <div className="content">
                        <h4 className="title">Phone</h4>
                        <a href="tel:6367607678">+91 6367607678</a>
                      </div>
                    </li>
                    <li>
                      <div className="icon">
                        <IoMailOpenOutline />
                      </div>
                      <div className="content">
                        <h4 className="title">E-mail</h4>
                        <a href="mailto:support@vinayak24x7.com">
                          support@vinayak24x7.com
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="contact__form-wrap">
                <h2 className="title">We're Ready, Let's Talk.</h2>
                {/* <p>Your email address will not be published. Required fields are marked *</p> */}
                <form
                  id="contact-form"
                  action="https://apexa-html-demo.netlify.app/assets/mail.php"
                  method="POST"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-grp">
                        <input type="text" name="name" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-grp">
                        <input type="number" name="phone" placeholder="Phone" />
                      </div>
                    </div>
                  </div>
                  <div className="form-grp">
                    <textarea
                      name="message"
                      placeholder="Message"
                      defaultValue={""}
                    />
                  </div>
                  {/* <div class="form-grp checkbox-grp">
                              <input type="checkbox" name="checkbox" id="checkbox">
                              <label for="checkbox">Save my name, email, and website in this browser for the next time I comment.</label>
                          </div> */}
                  <button type="submit" className="btn">
                    Submit
                  </button>
                </form>
                <p className="ajax-response mb-0" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="contact-map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3559.3704506001613!2d75.78387707543763!3d26.85996897667862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDUxJzM1LjkiTiA3NcKwNDcnMTEuMiJF!5e0!3m2!1sen!2sin!4v1771255958330!5m2!1sen!2sin"
                  width="100%"
                  height={450}
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
